<template>
	<div id="merchant" class="gcardfr" v-loading="loading">
		<el-row :gutter="20" class>
			<el-col :span="12">
				<el-button size="small" type="primary" icon="el-icon-plus" @click="addTer">{{ $t("merchant.merchant_add") }}</el-button>
				<el-button size="small" @click="batchDel" :disabled="sRows.length == 0" type="danger" plain>{{ $t("app_mulDel") }}
				</el-button>
				<el-button size="small" type @click="ImportMc">{{ $t("app_mulAdd") }}</el-button>
				<el-button size="small" type @click="exportMc">{{ $t("merchant.export_merchant") }}</el-button>
			</el-col>
			<el-col :span="6" ssshow="$isAdminType()">
				<div class="glineflex">
					<label class="glinelb">{{ $t("terminal.app_distributor") }}：</label>
					<Merchant :config="sortMc"></Merchant>
				</div>
			</el-col>
			<el-col oooffset="$isAdminType()?0:6" :span="6">
				<div class="glineflex">
					<label class="glinelb">{{ $t("merchant.store_name") }}：</label>
					<el-input size="small" v-model="srcEquip" @keyup.enter.native="indexget" placeholder></el-input>
				</div>
			</el-col>
		</el-row>
		<el-table ref="multipleTable" class="gtbtop" tooltip-effect="dark" @row-click="rowClick" :data="tableData"
			@selection-change="batchSelected" style="width: 100%">
			<el-table-column type="selection" width="55"></el-table-column>
			<el-table-column prop="merchantId" :label="$t('merchant.merchant_id')" width></el-table-column>
			<el-table-column prop="merchantName" :label="$t('merchant.merchant_name')" width></el-table-column>
			<!-- <el-table-column
        prop="contacts"
        label="联系人"
        width="">
      </el-table-column>-->
			<el-table-column v-if="$isAdminType()" prop="agentName" :label="$t('terminal.app_distributor')"></el-table-column>
			<el-table-column prop="merchantNo" :label="$t('merchant.merchant_num')"></el-table-column>
			<el-table-column prop="subMerchant" width="190"  :label="$t('terminal.sub_organization')"></el-table-column>
			<el-table-column prop="channelNo" width="100"  :label="$t('merchant.merchant_can_num')"></el-table-column>
			<el-table-column prop="deviceNum" :label="$t('terminal.binding_device')" width></el-table-column>
			<el-table-column prop="createTime" :label="$t('app_add_time')" width="170"></el-table-column>
			<el-table-column :label="$t('app_operation')"  width="120">
				<template slot-scope="scope">
					<el-button type="text" @click="toDetail(scope.row)">{{ $t('app_detail') }}</el-button>
					<!-- <el-button type='text' @click='bindEquip(scope.row)'>绑定设备</el-button> -->
					<label class="opbline">|</label>
					<el-button @click="delRow(scope.row.merchantId)" type="text" class="opdcolor">{{ $t('app_delete') }}</el-button>
				</template>
			</el-table-column>
		</el-table>

		<Pages class="gpages" :cpage="page" :ctotal="total" :config="pconfig"></Pages>

		<el-dialog class="gstdia" :title="$t('app_import_result')" :visible.sync="showIpRs">
			<el-table tooltip-effect="dark" :data="importData" style="width: 100%">
				<el-table-column prop="msg" :label="$t('app_description')" width></el-table-column>
			</el-table>
		</el-dialog>

		<el-dialog @open='preSet' @close="closeDia" class="gstdia" :title="$t('merchant.merchant_add')" :visible.sync="showDia">
			<el-form :model="tform" :rules="rules" ref="ruleForm">
				<el-form-item :label="$t('merchant.store_name')" :label-width="$formlbWidth" prop="merchantName">
					<el-input v-model="tform.merchantName" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('merchant.merchant_name')" :label-width="$formlbWidth" prop>
					<el-input v-model="tform.contacts" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('merchant.merchant_tel')" :label-width="$formlbWidth" prop>
					<el-input v-model="tform.merchantPhone" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item vvif="$isAdminType()" :label="$t('terminal.app_distributor')" :label-width="$formlbWidth" prop="merchant">
					<Merchant :config="editMc"></Merchant>
				</el-form-item>

				<el-form-item :label="$t('merchant.merchant_num')"  :label-width="$formlbWidth" prop>
					<el-input v-model="tform.merchantNo" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('terminal.sub_organization')" :label-width="$formlbWidth" prop>
					<el-input v-model="tform.subMerchant" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('merchant.merchant_can_num')" :label-width="$formlbWidth" prop>
					<el-input v-model="tform.channelNo" :placeholder="$t('merchant.merchant_pla')" autocomplete="off">
					</el-input>
				</el-form-item>

				<el-form-item :label-width="$formlbWidth">
					<el-button @click="closeDia">{{ $t('app_cancel') }}</el-button>
					<el-button type="primary" @click="beforeRqs">{{ $t('app_sure') }}</el-button>
				</el-form-item>
			</el-form>
			<!-- <div slot="footer" class="dialog-footer">        
      </div>-->
		</el-dialog>

		<EquipList :show="showEquDia" :config="econfig"></EquipList>
		<IpMc :config="config"></IpMc>
	</div>
</template>

<style>
	.eqbs-ball-green {
		width: 6px;
		height: 6px;
		display: inline-block;
		border-radius: 6px;
		overflow: hidden;
		background: rgba(82, 196, 26, 1);
	}

	.eqbs-ball-gray {
		width: 6px;
		height: 6px;
		display: inline-block;
		border-radius: 6px;
		overflow: hidden;
		background: rgba(191, 191, 191, 1);
	}
</style>

<script>
	import Pages from "@/components/Pages.vue";
	import Merchant from "@/components/Merchant.vue";
	import EquipList from "@/components/EquipList.vue";
	import IpMc from "@/components/ImportMerchant.vue";
	export default {
		data() {
			return {
				importData: [],
				showIpRs: false,
				sortMc: {},
				editMc: {},
				srcEquip: "",
				agentId: "",
				pconfig: "",
				tableData: [],
				showDia: false,
				showBcDia: true,
				tform: {
					merchantId: "",
					merchantName: "",
					merchantPhone: "",
					contacts: "",
					merchant: "",
					optionsProduct: [],
					merchantNo: "",
					subMerchant: "",
					channelNo: ""
				},
				bcform: {},
				page: 1,
				total: 0,
				loading: false,
				sRows: [],
				config: "",
				econfig: {},
				showEquDia: false,
				merchantId: "",
				rulesbc: {
					merchantName: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}]
				},
				rules: {
					merchantName: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}],
					contacts: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}],
					merchantPhone: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}],
					merchant: [{
						required: true,
						message: this.$t("app_select"),
						trigger: "blur"
					}],
					merchantId: [{
						required: true,
						message: this.$t("app_select"),
						trigger: "blur"
					}],
					merchantNo: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}],
					subMerchant: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}],
					channelNo: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}]
				}
			};
		},
		components: {
			Pages,
			Merchant,
			EquipList,
			IpMc
		},
		methods: {
			preSet() {
				//// set df mc, is agentid
				var usr = this.$getTmp('user')
				this.tform.merchant = usr.agentId
				this.setMcCtr(usr.agentId)
			},
			exportMc() {
				var ag = this.agentId ? this.agentId : "";
				var name = this.srcEquip ? this.srcEquip : "";
				this.$outputMerchant(ag, name);
			},
			ImportMc() {
				var _this = this;
				this.config = {
					type: 0, //// 0.
					agid: "",
					showDia: true,
					callback: data => {
						_this.getList();
						if (data.length > 0) {
							_this.importData = data;
							_this.showIpRs = true;
						}
					}
				};
			},
			indexget() {
				this.page = 1;
				this.getList();
			},
			rowClick(row, column) {
				if (column.label != this.$t("app_operation")) {
					this.toDetail(row);
				}
			},
			bindRqs(did) {
				if (did.length != 0) {
					this.$bindMerch(
						this.merchantId,
						did,
						res => {
							if (res.status == 200) {
								this.getList();
								this.showEquDia = false;
								this.$message.success(res.message);
							} else {
								this.$message.error(res.message);
							}
						},
						""
					);
				} else {
					this.showEquDia = false;
				}
			},
			rowClick(row, column) {
				if (column.label != this.$t("app_operation")) {
					this.toDetail(row);
				}
			},
			batchDel() {
				this.$showMsgBox(
					this.$t("app_delete_question_2"),
					() => {
						var arr = [];
						this.sRows.forEach(item => {
							arr.push(item.merchantId);
						});
						this.delRqs(arr.toString());
					},
					""
				);
			},
			delRqs(id) {
				this.loading = true;
				this.$delMerch(
					id,
					res => {
						this.loading = false;
						if (res.status == 200) {
							this.getList();
						} else {
							this.$message.error(res.message);
						}
					},
					() => {
						this.loading = false;
					}
				);
			},
			delRow(id) {
				this.$showMsgBox(
					this.$t("app_delete_question"),
					() => {
						this.delRqs(id);
					},
					""
				);
			},
			addTer() {
				this.showDia = true;
				this.setMcCtr("");
			},
			toDetail(row) {
				this.$router.push({
					path: "/merchant/detail",
					query: {
						deviceid: "",
						merchantId: row.merchantId,
						mcno: row.merchantNo
					}
				});
			},
			bindEquip(row) {
				var _this = this;
				this.showEquDia = true;
				this.merchantId = row.merchantId;
				this.econfig = {
					mcid: row.merchantId,
					agid: row.agentId,
					type: 0,
					title: this.$t("merchant.merchant_equ"),
					callback: ids => {
						_this.bindRqs(ids);
					}
				};
			},
			getList() {
				this.loading = true;
				this.$merchList(
					this.page,
					this.$gRow,
					"",
					this.agentId ? this.agentId : "",
					this.srcEquip ? this.srcEquip : "",
					res => {
						this.loading = false;
						if (res.status == 200) {
							this.total = res.total;
							this.tableData = res.data;
						} else {
							this.$message.error(res.message);
						}
					},
					""
				);
			},
			batchSelected(val) {
				this.sRows = val;
			},
			closeDia() {
				this.showDia = false;
				this.tform.shopName = "";
				this.tform.merchantName = "";
				this.tform.merchantPhone = "";
				this.tform.merchantNo = "";
				this.tform.subMerchant = "";
				this.tform.channelNo = "";
				this.tform.contacts = "";
			},
			closeBcDia() {
				this.showBcDia = false;
				// this.tform.shopName = ''
			},
			beforeRqsBc() {
				this.$refs["ruleForm1"].validate(valid => {
					if (valid) {
						this.okDia();
					}
				});
			},
			beforeRqs() {
				this.$refs["ruleForm"].validate(valid => {
					if (valid) {
						this.okDia();
					}
				});
			},
			okDia() {
				//alert(this.tform.agentId)
				//console.log('merchant: okDia, '+' merchantName= '+this.tform.merchantName+' merchantPhone= '+this.tform.merchantPhone+' merchant= '+ this.tform.merchant)
				this.loading = true;
				this.$addMerch(
					this.tform.merchantName,
					this.tform.merchantPhone,
					this.tform.merchant,
					this.tform.contacts,
					this.tform.merchantNo,
					this.tform.subMerchant,
					this.tform.channelNo,
					res => {
						this.loading = false;
						if (res.status == 200) {
							this.closeDia();
							this.getList();
						} else {
							this.$message.error(res.message);
						}
					},
					""
				);
			},
			setMcCtr(vl) {
				var _this = this;
				this.editMc = {
					type: "1",
					size: "",
					value: vl ? vl : "",
					callback: vl => {
						_this.tform.merchant = vl
					}
				};
			}
		},
		mounted() {

			var _this = this;
			this.pconfig = {
				callback: page => {
					///
					_this.page = page;
					_this.getList();
				}
			};

			this.getList();

			this.sortMc = {
				size: "small",
				value: "",
				type: "0",
				callback: vl => {
					//alert(vl)
					this.agentId = vl;
					this.indexget();
				}
			};
		}
	};
</script>
